"use client";

import { AnimatedItem } from "@/components/componentAnimation/animatedItemComponent";
import styles from "./HeroSection.module.css";

type HeroSectionProps = {
  title: string;
};

export default function HeroSection({ title }: HeroSectionProps) {
  return (
    <AnimatedItem>
      <section className={styles.hero}>
        <div className={styles.heroInner}>
          <h1 className={styles.heroTitle}>{title}</h1>
        </div>
      </section>
    </AnimatedItem>
  );
}
